module.exports = __webpack_public_path__ + "static/media/tou_geren_icon@3x.3c297bd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/tou_geren_icon@3x.png
// module id = 668
// module chunks = 0